// 小程序——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `module/applet/index${i + 1}`,
  name: `module/appletIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/applet/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 小程序——主流程，开始
    ...MainRoutes
  ]
}
